module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"chat.preview":"Preview","cancel":"Cancel"},"zh":{"chat.preview":"预览","cancel":"取消"},"mm":{"chat.preview":"ပြန်ကြည့်","cancel":"ပယ်ဖျက်"}}')
  delete Component.options._Ctor
}
